// basic actions
const POST_SELECTED_WHEN = "POST_SELECTED_WEN";
const POST_SETTING = "POST_SETTING";
const POST_SELECTED_ZIP = "POST_SELECTED_ZIP";
const POST_SELECTED_ADDRESS = "POST_SELECTED_ADDRESS";
const POST_DAYS = "POST_DAYS";
const POST_SESSION_DETAILS = "POST_SESSION_DETAILS";
const POST_LANG = "POST_LANG";
const POST_PREFERRED = "POST_PREFERRED";
const POST_CATEGORY = "POST_CATEGORY";
const POST_TO_CART = "POST_TO_CART";
const POST_TO_CART_GLOCERY = "POST_TO_CART_GLOCERY";
const POST_SELECTED_CHEF = "POST_SELECTED_CHEF";
const POST_USER_DATA = "POST_USER_DATA";
const POST_CUISINE = "POST_CUISINE";
const TOGGLE_DIALOG = "TOGGLE_DIALOG";
const POST_LOGOUT = "POST_LOGOUT";
const POST_LANGUAGE_LOADING = "POST_LANGUAGE_LOADING";
const POST_LANGUAGE_ERROR = "POST_LANGUAGE_ERROR";
const POST_CART_TOTALS = "POST_CART_TOTALS";

export {
  POST_SELECTED_WHEN,
  POST_SETTING,
  POST_SELECTED_ZIP,
  POST_SELECTED_ADDRESS,
  POST_DAYS,
  POST_SESSION_DETAILS,
  POST_LANG,
  POST_PREFERRED,
  POST_CATEGORY,
  POST_TO_CART,
  POST_TO_CART_GLOCERY,
  POST_SELECTED_CHEF,
  POST_USER_DATA,
  POST_CUISINE,
  TOGGLE_DIALOG,
  POST_LOGOUT,
  POST_LANGUAGE_LOADING,
  POST_LANGUAGE_ERROR,
  POST_CART_TOTALS
};
